import { useState } from "react";
import { ModalAddMainData } from "../../ui/ModalAddMainData";
import { ImageTemp, MainData } from "../../../interfaces/intakes.reports";
import { IoCloudUploadOutline } from "react-icons/io5"
import { useTempImages } from "../../../hooks/useTempImages";
import toast from "react-hot-toast";
import { ImageSelected } from "../../ui/ImageSelected";
import { SpinnerCustom } from "../../ui/SpinnerCustom";

interface Props {
    mainData: MainData
    setMainData: React.Dispatch<React.SetStateAction<MainData>>
    handleImages?: (images: ImageTemp[]) => void
    images?: ImageTemp[]
    isInitial?: boolean
    fast?: boolean
}
export const MainDataAdd = ({ mainData, setMainData, images, handleImages, fast = false, isInitial = false }: Props) => {

    const [openModal, setOpenModal] = useState(false)

    const handleAddItem = (newMainData: MainData) => {
        setMainData(newMainData)
    };

    let buttonStyle = "tw-flex tw-h-10 tw-rounded-lg tw-justify-center tw-items-center tw-text-center tw-border"

    const { addImages, isLoading: isAddingTemp } = useTempImages()
    const addTempFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {

        if (!images || !handleImages) return;
        let limit = 20

        const files = e.currentTarget.files;

        if (files && files.length > 0) {
            if ((images.length + (files).length) > limit) {
                return toast.error(limit === 0 ? `You upload all the permitted images` : `You have ${limit - images.length} images left to upload`)
            }
            const data = await addImages(files)
            handleImages([...images, ...data])
        }
    };

    const removeTemp = (id: string) => {
        if (!images || !handleImages) return;
        const filterImages = images.filter(img => img.id !== id)
        handleImages(filterImages)
    };

    return (
        <>
            {
                openModal &&
                <ModalAddMainData
                    mainData={mainData}
                    closeModal={() => setOpenModal(false)}
                    handleAddItem={handleAddItem}
                    fast={fast}
                />
            }


            <div className="tw-grid tw-grid-cols-2">
                <div />
                <div>
                    <div className={`tw-grid ${isInitial ? "tw-grid-cols-2" : "tw-grid-cols-1"} tw-gap-2`}>
                        <button
                            className={`${buttonStyle} tw-bg-blue-600`}
                            onClick={() => setOpenModal(true)}>
                            <p className='tw-text-white tw-text-sm'>Add Items</p>
                        </button>
                        {
                            (isInitial && handleImages) &&
                            <>
                                <label htmlFor="newFiles" className={`${buttonStyle} tw-bg-green-600 tw-cursor-pointer`}>
                                    <p className='tw-text-white tw-text-sm'>Batch Images</p>
                                </label>

                                <input
                                    id="newFiles"
                                    className="upload-btn"
                                    accept="image/*"
                                    multiple
                                    name="file"
                                    type="file"
                                    onChange={addTempFiles}
                                />
                            </>
                        }
                    </div>

                    {
                        (images && images.length > 0 || isAddingTemp) &&
                        <div className="mt-1 mb-2">
                            <ImageSelected images={images || []} removeTempFiles={removeTemp} />
                            {isAddingTemp && <SpinnerCustom center size="s" color="green" />}
                        </div>
                    }
                </div>


            </div>
        </>
    )
}
